import { render, staticRenderFns } from "./SignUpFormComponent.vue?vue&type=template&id=4287a87e&"
import script from "./SignUpFormComponent.vue?vue&type=script&lang=ts&"
export * from "./SignUpFormComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4287a87e')) {
      api.createRecord('4287a87e', component.options)
    } else {
      api.reload('4287a87e', component.options)
    }
    module.hot.accept("./SignUpFormComponent.vue?vue&type=template&id=4287a87e&", function () {
      api.rerender('4287a87e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/SignUpFormComponent.vue"
export default component.exports